<div class="main-section-container">
  <div class="main-section-container-inner">
    <div class="main-section-title-container">
      <div class="main-section-title-label-1">
        13-26 июня 2025
      </div>
      <div class="main-section-title-label-2">
        Ледовый дворец Витязь,
        г. Подольск, Московская область
      </div>
      <div class="main-section-title-label-3">
        Сборы компании
        GOLD STAR в России
      </div>
      <div class="main-section-title-label-4">
        Хоккейные сборы для юных талантов, родившихся
        не позднее 2013 года, с участием игроков из МХЛ и КХЛ
      </div>
      <app-button (click)="emitScroll.emit()" class="main-section-title-label-5">
        Регистрация
      </app-button>
      <div class="main-section-title-label-6">
        «Не жди идеального момента. Бери то, что есть, и делай его идеальным.»<br>
        Дэн Мильштейн
      </div>
    </div>
  </div>
</div>
